import React, { useContext, useEffect } from "react";
import { useCareRecipientList } from "../../../hooks/care_recipient/useCareRecipientList";
import { CareRecipientListContext } from "../../../provider/CareRecipientListProvider";
import { Loading } from "../../common/Loading";
import { NoData } from "../../common/no_data/NoData";
import { CareRecipientListItem } from "./CareRecipientListItem";
import { useAppDispatch } from "../../../../state/store";
import { getCareRecipientLatestInfoAction } from "../../../../state/usecase/report/actions";

export const CareRecipientList = React.memo(function CareRecipientList() {
    const { displayList } = useContext(CareRecipientListContext);

    const dispatch = useAppDispatch();

    const { careRecipients, isLoading } = useCareRecipientList();

    useEffect(() => {
        dispatch(getCareRecipientLatestInfoAction());
    }, [dispatch]);

    if (isLoading) {
        return <Loading />;
    }

    return !careRecipients.length ? (
        <NoData />
    ) : displayList.length ? (
        <ul className={"care_recipient_list"}>
            {displayList.map(careRecipient =>(
                <CareRecipientListItem
                    key={careRecipient.id.value}
                    careRecipient={careRecipient}
                />
            ))}
        </ul>
    ) : <></>;
});
